import { ConnectIntegrationForm } from "../connect-integration-form"
import { use_connect_redirect_to } from "../use_connect_redirect_to"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectRoadtexPage(props: any = {}) {
  const redirectTo = use_connect_redirect_to(props.redirectTo)

  return (
    <ConnectIntegrationForm
      integrationName="roadtex"
      redirectTo={redirectTo}
      logoAlt="Roadtex Transportation"
      description="Enter your Roadtex Customer Connect credentials (customerconnect.roadtex.com). We read the freight bills Roadtex emails you and the carrier's own delivery record and proof of delivery for every shipment, then set them against the retailer's on-time / in-full fees."
    />
  )
}
